import makeCrudModule from '@/factories/CrudModelFactory';
import landingpagesService from '@/services/crosssell';

export default makeCrudModule({
    service: landingpagesService,
    dateConvert: [
        'created_at', 'updated_at', 'deactivated_at'
    ]
});
